import '../../App.css';
import React, { useContext, useEffect, useState } from "react";
import { FaTimes } from 'react-icons/fa';
import { TbTrash } from 'react-icons/tb';
import { Form, Row, Col, Tabs, Tab } from 'react-bootstrap';
import { ApiContext } from '../../context/ApiContext';
import { StyleContext } from '../../context/StyleContext';
import SelectMultiplo from '../SelectMultiplo';

function ModalNovaLinhaAtendimento({ closeModal, currentPage }) {

    const { getEmpresa, AdicionarLinha, ListaPessoa, Pessoas, ListaArea, Areas, setCadastroLinha, ListaCargo, ListaPessoaPorCargo, Cargos, PessoasPorCargo, setPessoasPorCargo, setError, ItensLinha, setItensLinha } = useContext(ApiContext)
    const { btnVer, btnCriar } = useContext(StyleContext)
    const [Nome, setNome] = useState()
    const [Descricao, setDescricao] = useState()
    const [Status, setStatus] = useState(true)
    const [Responsavel, setResponsavel] = useState()
    const [cargo, setCargo] = useState()
    const [pessoa, setPessoa] = useState()

    const salvarDemanda = () => {
        AdicionarLinha(Nome, Descricao, Status, Responsavel, currentPage)
            .then(() => {
                closeModal(false)
            })
            .catch((error) => {
            })
    }

    useEffect(() => {
        ListaPessoa()
        ListaArea()
        ListaCargo()
        getEmpresa()
    }, [])

    useEffect(() => {
        if (cargo && cargo !== "0" && cargo !== 0) {
            try {
                const parsedCargo = JSON.parse(cargo);
                ListaPessoaPorCargo(parsedCargo.key);
                setPessoa(0);
            } catch (e) {
            }
        } else {
            setPessoa(0);
            setPessoasPorCargo([]);
        }
    }, [cargo]);

    const areasOptions = (Areas || []).map((org) => ({
        label: org.descricao,
        value: org.key,
    }));

    const [areasSelecionadas, setAreasSelecionadas] = useState([]);

    const handleAreasChange = (selectedOptions) => {
        setAreasSelecionadas(selectedOptions);

        const areasKeys = selectedOptions.map((org) => ({
            areaKey: org.value,
        }));

        setCadastroLinha((prev) => ({
            ...prev,
            areas: areasKeys,
        }));
    };


    const AdicionarItem = () => {
        if ((!cargo && !pessoa) || (cargo === 0 && pessoa === 0) || (cargo === "0" && pessoa === "0")) {
            setError("Informe um valor.");
            setTimeout(() => {
                setError("");
            }, 3000);
            return;
        } else if ((cargo && !pessoa) || (cargo && pessoa === 0) || (cargo && pessoa === "0")) {
            setError("Pessoa não informada.");
            setTimeout(() => {
                setError("");
            }, 3000);
            return;
        } else if ((pessoa && !cargo) || (pessoa && cargo === 0) || (pessoa && cargo === "0")) {
            setError("Cargo não informado.");
            setTimeout(() => {
                setError("");
            }, 3000);
            return;
        }
        let data = {
            pessoa: JSON.parse(pessoa).nome,
            pessoaKey: JSON.parse(pessoa).key,
            cargo: JSON.parse(cargo).descricao,
            cargoKey: JSON.parse(cargo).key
        };

        setItensLinha((ItensLinha) => [...ItensLinha, data]);
        setCargo(0)
        setPessoa(0)
    }

    const ExcluirItem = (pessoaKey, cargoKey) => {
        const novosItens = ItensLinha.filter((item) => item.pessoaKey !== pessoaKey || item.cargoKey !== cargoKey);
        setItensLinha(novosItens);
    }

    return (
        <div className="modal-novo">
            <div className="modal-novo-interno">
                <div className="header-modal">
                    <div>
                        <h1 className="h1-modal">Novo cadastro</h1>
                    </div>
                    <div className="btn-close-modal" onClick={() => closeModal(false)}>
                        <FaTimes />
                    </div>
                </div>
                <div className="modal-content">
                    <form className="mb-3">
                        <Tabs className='mt-3 mb-3'>
                            <Tab eventKey="geral" title={<span>Visão Geral</span>}>
                                <Row style={{ alignItems: 'center' }}>
                                    <Col xs={10}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Time</Form.Label>
                                            <Form.Control maxLength={100} value={Nome} onChange={(e) => setNome(e.target.value)} name="nome" />
                                        </Form.Group>
                                    </Col>
                                    <Col className='mt-2'>
                                        <div className="checkbox-wrapper" style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                                            <input type="checkbox" label="Ativo" name='status' checked={Status} onChange={(e) => setStatus(e.target.checked)} className="toggleBtn" />
                                            <p className="modal-status">Ativo</p>
                                        </div>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Responsável</Form.Label>
                                            <Form.Select aria-label="Default select example" onChange={(e) => setResponsavel(e.target.value)} name="responsavelKey">
                                                <option value="">Selecione</option>
                                                {Pessoas && Pessoas?.map((l) => {
                                                    return (
                                                        <option key={l.id} value={l.key}>{l.nome}</option>
                                                    )
                                                })}
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>
                                    <Col>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Áreas Atendidas</Form.Label>
                                            <SelectMultiplo
                                                options={areasOptions}
                                                value={areasSelecionadas}
                                                onChange={handleAreasChange}
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Descrição</Form.Label>
                                        <Form.Control maxLength={255} value={Descricao} onChange={(e) => setDescricao(e.target.value)} name="descricao" as="textarea" rows={3} />
                                    </Form.Group>
                                </Row>
                            </Tab>
                            <Tab eventKey="pessoas" title={<span>Pessoas</span>}>
                                <Row style={{ alignItems: 'center' }}>
                                    <Col xl={5}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Cargo</Form.Label>
                                            <Form.Select aria-label="Default select example" value={cargo} onChange={(e) => setCargo(e.target.value)} name="cargoKey">
                                                <option value={0}>Selecione</option>
                                                {Cargos &&
                                                    Cargos?.map((item) => {
                                                        return (
                                                            <option key={item.id} value={JSON.stringify({ descricao: item.descricao, key: item.key })}>{item.descricao}</option>
                                                        )
                                                    })

                                                }
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>
                                    <Col xl={5}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Pessoa</Form.Label>
                                            <Form.Select aria-label="Default select example" value={pessoa} onChange={(e) => setPessoa(e.target.value)} name="pessoaKey">
                                                <option value={0}>Selecione</option>
                                                {PessoasPorCargo &&
                                                    PessoasPorCargo?.map((item) => {
                                                        return (
                                                            <option key={item.id} value={JSON.stringify({ nome: item.nome, key: item.key })}>{item.nome}</option>
                                                        )
                                                    })

                                                }
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>
                                    <Col xl={2}>
                                        <button type="button" className="btn-dash btn-ver mt-3" style={btnVer} onClick={() => AdicionarItem()}>Adicionar</button>
                                    </Col>
                                </Row>
                                <Row>
                                    <div className="secao-comentario">
                                        {ItensLinha &&
                                            ItensLinha?.map((item, index) => {
                                                return (
                                                    <div key={index} className="content-comentario">
                                                        <div className="div-comentario" style={{ flexDirection: 'column', alignItems: 'start' }}>
                                                            <p className="p-title" style={{ marginLeft: '5px' }}>Cargo</p>
                                                            <span>{item.cargo}</span>
                                                        </div>
                                                        <div className="div-comentario" style={{ flexDirection: 'column', alignItems: 'start' }}>
                                                            <p className="p-title" style={{ marginLeft: '5px' }}>Pessoa</p>
                                                            <span>{item.pessoa}</span>
                                                        </div>
                                                        <div className="div-button">
                                                            <button type="button" className="btn-del" onClick={() => ExcluirItem(item.pessoaKey, item.cargoKey)}><TbTrash /></button>
                                                        </div>
                                                    </div>
                                                )
                                            })}
                                    </div>
                                </Row>
                            </Tab>
                        </Tabs>

                    </form>
                </div>
                <div className="footer-modal">
                    <button type="submit" className="btn-dash btn-ver" style={btnVer} onClick={() => closeModal(false)}>Cancelar</button>
                    <button type="submit" className="btn-dash btn-criar" style={btnCriar} onClick={() => salvarDemanda()}>Salvar</button>
                </div>
            </div>
        </div>
    )
}

export default ModalNovaLinhaAtendimento